import styled from "styled-components";

import { InquiryOverviewPageStyle } from "@pages/inquiryOverviewPage/inquiryOverviewPageStyle";

export const AssetsPageStyle = styled(InquiryOverviewPageStyle)``;
